import { images } from "../../assets/images"

export const Mobile = () => {
    return (<main className="welcome__desktop ">
        <header className="welcome__desktop-header">
            <a href="https://skinsagency.com">
                <img src={images.logo} alt="logo" />
            </a>
        </header>
        <div className="welcome__error">
            <p className="welcome__error-text">
                Uh Oh!
            </p>
        </div>
        <h2 className="welcome__mobile-title">
            This app does not work in mobile. Please use desktop.
        </h2>
        <p className="welcome__mobile-footer">
            On your desktop, please visit <a href="https://app.skinsagency.com" className="has-yellow-text">app.skinsagency.com</a>
        </p>
        <div className="welcome__mobile register welcome-cta">
            <a className="btn" href="https://brandpack.us/">
                <span>
                    Go Back
                </span>
            </a>
        </div>
    </main>)
}